export var Errors;
(function(Errors) {
    Errors["SEARCH_ALERTS_FETCH_ERROR_API_ERROR"] = "Search alerts - Fetch error - API error";
    Errors["SEARCH_RESULTS_API_ERROR"] = "Search Results - API error";
})(Errors || (Errors = {}));
